import React, { useContext } from 'react'
import { StepFooterStyles } from './Style'
import { LinearProgress } from '@mui/material'
import { CacheProvider } from '@emotion/react'
import { cacheLtr } from 'styles/theme'
import { CreateAssessmentDefContext } from './CreateAssessmentDefContext'
import ActionButtons from './ActionButtons'

const StepFooter = () => {
    const { createAssessmentStep, goNextStep, categoryItem } = useContext(CreateAssessmentDefContext)

    return (
        <StepFooterStyles>
            <CacheProvider value={cacheLtr}>
                <div className='steps'>
                    <div onClick={() => goNextStep(0)} className={`step ${!createAssessmentStep && "selected-step"}`}>
                        <div className='step-title'>{"פרטי המבדק"}</div>
                        <LinearProgress color='dark' variant="determinate" value={0} />
                    </div>
                    <div onClick={() => goNextStep(1)} className={`step ${createAssessmentStep && "selected-step"}`}>
                        <div className='step-title'>{categoryItem?.label || "תוכן המבדק"}</div>
                        <LinearProgress color='dark' variant="determinate" value={0} />
                    </div>
                </div>
                <ActionButtons />
            </CacheProvider>
        </StepFooterStyles>
    )
}

export default StepFooter